import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"opacity":"styles_opacity__ycwwn","on":"styles_on__HZso0","slide":"styles_slide__fygqz","left":"styles_left__ftAv6","right":"styles_right__MMyil","top":"styles_top__LLqKo","bottom":"styles_bottom__h2wvi"};
export const b = b_.with('opacity');